export default __webpack_public_path__ + "static/media/item_ex_4.5444ed4a.png";